import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import UploadPaper from '@/components/papers/UploadPaper';
import HeaderWithBackButton from '@/components/common/HeaderWithBackButton';
import SEOHead from '@/components/common/SEOHead';
import { SITE_URL } from '@/lib/constants/urls';

const Upload = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const visibility = searchParams.get('visibility');
  const source = searchParams.get('source');
  
  // Determine page context for SEO
  const isExternalTab = tab === 'external' || source === 'arxiv';
  const isPrivate = visibility === 'private';
  
  const description = isPrivate
    ? "Get confidential AI-powered feedback on your draft before submission. Upload securely, iterate with detailed reviews, and share only when you're ready."
    : isExternalTab
    ? "Link your paper from arXiv, bioRxiv, or other preprint servers to PaperVerse. Get reviews and discussions for externally hosted research papers."
    : "Strengthen your paper with confidential AI feedback, or share published work with the research community on PaperVerse.";
  
  const keywords = isPrivate
    ? "private paper upload, AI paper review, automated feedback, research iteration, private research, AI-powered review"
    : isExternalTab
    ? "link research paper, arXiv paper, bioRxiv paper, external paper link, preprint server integration, research paper discussion"
    : "upload research paper, share research, peer review submission, research collaboration, paper upload, academic paper submission, direct upload";
  
  const pageTitle = isPrivate 
    ? "Get Feedback on Your Draft | PaperVerse"
    : isExternalTab 
    ? "Link External Paper | PaperVerse" 
    : "Strengthen Your Paper | PaperVerse";
    
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": isPrivate ? "Upload Private Research Paper" : isExternalTab ? "Link External Research Paper" : "Upload Research Paper",
    "description": description,
    "url": `${SITE_URL}/upload`
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SEOHead 
        title={pageTitle}
        description={description}
        canonicalUrl={`${SITE_URL}/upload`}
        keywords={keywords}
        structuredData={structuredData}
        noindex
      />
      <Navbar />
      
      <main className="flex-1 pt-8 pb-16 mt-6">
        <div className="max-w-3xl mx-auto px-4">
          <HeaderWithBackButton 
            title="Strengthen Your Paper"
            subtitle="Upload your manuscript for confidential AI feedback, or share published work with the community."
          />
          
          <UploadPaper />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Upload;
